@for (section of sections; track section) {
  <div class="row table-row no-gutters feedback-section"
    [class.selected]="section===selected">
    <div class="col-12 clickable section-header" style="display:flex">
      <span (click)="select(section)" style="flex-grow: 1">{{section.title}} @if (edited(section)) {
        <span class="edited"
        >(edited)</span>
      }</span>
      <!---  <app-gphc-icon *ngIf="section===selected" [iconType]="'info'" [offset]="-10"
      [offsetTop]="-5"
    (click)="helpClick($event, section)"></app-gphc-icon>-->
    @if (review.isFeedbackEditable) {
      <button (click)="toggleEdit(section)">
        <i class="fa fa-pencil" appTooltip="Edit feedback"></i>
      </button>
    }
    @if (section===selected && edited(section)) {
      <button  (click)="undo(section)">
        <i class="fa fa-undo"></i>
      </button>
    }
  </div>
  <app-collapsible class="col-12 root-collapsible" [trigger]="section===selected">
    <app-collapsible [trigger]="section.helpVisible" class="help-block">
    </app-collapsible>
    <div style="padding-bottom: 10px;">
      @if (section.isFeedback && section.editing) {
        <app-text-editor (contentChanged)="update($event)"
          [content]="review.feedbackEdit[section.feedbackType]" [hasFocus]="section===selected" [id]="feedback" [isReviewFeedbackSection]="true">
        </app-text-editor>
      }
      @if (section.isFeedback && !section.editing) {
        <div (click)="toggleEdit(section)">
          @if (review.feedbackEdit[section.feedbackType]) {
            <div [innerHTML]="review.feedbackEdit[section.feedbackType]">
            </div>
          }
          @if ( !review.feedbackEdit[section.feedbackType]) {
            <div>
              No feedback yet.
            </div>
          }
        </div>
      }
      @if (section.isAssessment) {
        <app-assessment (feedbackEdited)="checkHasEdits()" [review]="review" [editing]="section.editing"></app-assessment>
      }
    </div>
  </app-collapsible>
</div>
}